import React from "react";
import { sizeUnits } from "_constants";
import PropTypes from "prop-types";

import Dropdown from "components/Dropdown";
import { Translate } from "utils";

const { t } = new Translate();

const valueExtractor = (unit, value) => unit && t(`units.${unit}`, value && parseInt(value, 10));

const UnitField = ({ field: { name, value }, form: { setFieldValue }, units }) => (
  <Dropdown
    inputComponentProps={{ size: 32 }}
    inputValueExtractor={(v) => valueExtractor(v, value)}
    onChange={(v) => setFieldValue(name, v)}
    selectedValues={[value]}
    valueExtractor={(v) => ({ label: valueExtractor(v, value) })}
    values={units}
  />
);

UnitField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  units: PropTypes.arrayOf(PropTypes.string),
};

UnitField.defaultProps = {
  units: sizeUnits,
};

export default UnitField;
